import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import CustomApp from "../../models/customApp";
import { saveState, loadState, removeState } from "../browser-storage/browser-storage";

type InitialState = {
    customApp: CustomApp
}
const type = 'customApp'

const initialState: InitialState = {
    customApp: loadState(type)
}

export const customAppSlice = createSlice({
    name: type,
    initialState: initialState,
    reducers: {
        setCustomApp: (state, action: PayloadAction<CustomApp>) => {
            state.customApp = action.payload;
            saveState(type, action.payload)
        },
        removeCustomApp: (state) => {
            state.customApp = {};
            removeState(type)
        },
    },
});

// Action creators are generated for each case reducer function
export const { setCustomApp, removeCustomApp } = customAppSlice.actions;

export default customAppSlice.reducer;
